import script from "./AddEditOnboarding.vue?vue&type=script&setup=true&lang=js"
export * from "./AddEditOnboarding.vue?vue&type=script&setup=true&lang=js"

import "./AddEditOnboarding.vue?vue&type=style&index=0&id=09b98eed&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Utilizador\\Desktop\\projetos\\owlpharma-hrm\\src\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09b98eed"]])

export default __exports__